module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@2x-097fd0722373e3a1458f927e39f7095c.png";